@if (loading) {
  <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
}
<div class="container">
  <div class="left-tab-viewer">
    <div class="list">
      <mat-selection-list [multiple]="false" [hideSingleSelectionIndicator]="true" (selectionChange)="selectionChange($event)">
        @for (report of reports; track report) {
          <mat-list-option [value]="report" [selected]="report.selected">
            <div class="report-list-item">
              <div class="report-name">{{report.name}}</div>
              <div class="report-meta">
                @if (report.report_type) {
                  <span class="report-type-badge">{{ getTypeLabel(report.report_type) }}</span>
                }
                <span class="report-date">{{report.updated_at | date: 'MMM d, yyyy'}}</span>
              </div>
            </div>
          </mat-list-option>
        }
      </mat-selection-list>
    </div>
    <div class="content">

      @if (!reports.length) {
        <div class="empty-state">
          No report templates found.
          <button mat-button color="accent" class="mat-inline-button" [disabled]="!('create' | able: newReport)"
            (click)="toggleForm(null, true)" aria-label="Add" title="Add">
          Add report?</button>
        </div>
      }

      <form #vcForm [formGroup]="inputForm">
        <section style="display: none;">
          <input matInput type="text" formControlName="id" />
        </section>
        <div class="row">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input matInput type="text" autocomplete="off" formControlName="name" [errorStateMatcher]="matcher" [readonly]="!canEdit" />
            @if (inputForm.controls.name.hasError('required')) {
              <mat-error>
                This field is <strong>required</strong>
              </mat-error>
            }
          </mat-form-field>

          <div class="icons">
            @if (report?.id) {
              <button mat-icon-button aria-label="Add" color="none" (click)="toggleForm(null, true)" [disabled]="!('create' | able: newReport)">
                <mat-icon title="Add">add</mat-icon>
              </button>
            }
            <button mat-icon-button aria-label="Save" color="none" (click)="save(inputForm)" [disabled]="!canEdit">
              <mat-icon title="Save">save</mat-icon>
            </button>
            @if (report?.id) {
              <button mat-icon-button aria-label="Delete" color="warn" (click)="delete(report)" [disabled]="!('delete' | able: report)">
                <mat-icon title="Delete">delete</mat-icon>
              </button>
            }
          </div>
        </div>

        @if (report?.id) {
          <div class="type-toggles">
            <label class="type-toggles-label">Use as</label>
            <div class="type-chips">
              @for (type of reportTypes; track type.value) {
                <button
                  type="button"
                  (click)="toggleReportType(type.value)"
                  [class.active]="inputForm.controls.report_type.value === type.value"
                  class="type-chip"
                  >
                  @if (inputForm.controls.report_type.value === type.value) {
                    <mat-icon class="chip-icon">check</mat-icon>
                  }
                  {{ type.label }}
                </button>
              }
            </div>
          </div>
        } @else {
          <div class="type-toggles">
            <label class="type-toggles-label">Use as</label>
            <div class="type-hint">Save the template first to assign a type</div>
          </div>
        }

        <section class="editor-section">
          <label class="editor-label">Template (YAML)</label>
          <div #editorContainer class="editor-container"></div>
          @if (inputForm.controls.template.hasError('required')) {
            <mat-error class="editor-error">
              This field is <strong>required</strong>
            </mat-error>
          }
        </section>
      </form>

    </div>
  </div>
</div>
